// Maps the technical offline-queue formName (e.g. "profile-edit") to a
// human-friendly i18n label so the sync popover and toasts never show raw
// internal identifiers to users. Unknown forms fall back to a generic label.
const FORM_LABEL_KEYS: Record<string, string> = {
    'profile-edit': 'sync.forms.profileEdit',
    'company-create': 'sync.forms.companyCreate',
    'company-edit': 'sync.forms.companyEdit',
    'customer-create': 'sync.forms.customerCreate',
    'customer-edit': 'sync.forms.customerEdit',
    'config-create': 'sync.forms.configCreate',
    'config-edit': 'sync.forms.configEdit',
    'user-create': 'sync.forms.userCreate',
    'user-edit': 'sync.forms.userEdit',
    'invoice-create': 'sync.forms.invoiceCreate',
    'invoice-edit': 'sync.forms.invoiceEdit',
    'quote-create': 'sync.forms.quoteCreate',
    'quote-edit': 'sync.forms.quoteEdit',
};

export function syncFormLabel(formName: string | undefined | null, t: (key: string) => string): string {
    const key = formName ? FORM_LABEL_KEYS[formName] : undefined;
    return key ? t(key) : t('sync.genericForm');
}
